var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Layout",
    {
      attrs: {
        clientId: _vm.clientId,
        showid: _vm.topicId,
        channels: _vm.channels,
        setTitle: _vm.title,
        apiOrigin: _vm.apiOrigin
      }
    },
    [
      _c("div", [
        _c(
          "div",
          { staticClass: "article" },
          [
            _c("imgList", { attrs: { list: _vm.topicList } }),
            _vm._v(" "),
            _c(
              "a",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.meta.page_count > _vm.meta.current_page,
                    expression: "meta.page_count>meta.current_page"
                  }
                ],
                staticClass: "more",
                attrs: {
                  disabled: _vm.showMore == "加载中",
                  href: "javascript:;",
                  id: "pc-more"
                },
                on: { click: _vm.more }
              },
              [_vm._v(_vm._s(_vm.showMore))]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.topicList.length == 0 ||
                      _vm.meta.page_count == _vm.meta.current_page,
                    expression:
                      "topicList.length==0||meta.page_count==meta.current_page"
                  }
                ],
                staticClass: "more",
                attrs: { href: "javascript:;", id: "pc-more" }
              },
              [_vm._v("没有更多了")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "aside" },
          [
            _c("newsImgAside", {
              attrs: {
                title: "热门新闻",
                clientId: _vm.clientId,
                list: _vm.reWenList
              }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-391de9d7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-391de9d7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/web/page/news-pc/topic-list.vue
// module id = null
// module chunks = 